import { createContext } from "react";

const offsetContext = createContext();

export default offsetContext;